module.exports = __webpack_public_path__ + "img/studentinterestdelivery.d4896bc7.jpg";